<template>
	<div class="outer">
		<div class="banner-top">
			<div class="flex-row items-center">
				<div class="icon-location item-left flex-row items-center">
					<img src="../../assets/image/p-1.png" class="image-icon" />
					<span class="text-top">位置 - {{webInfo.adderss}}</span>
				</div>
				<div class="icon-download item-left flex-row items-center">
					<img src="../../assets/image/p-2.png" class="image-icon" />
					<span class="text-top"><a target="_blank" :href=href>APP下载</a></span>
				</div>
				<div class="icon-telephone item-left flex-row items-center">
					<img src="../../assets/image/p-3.png" class="image-icon" />
					<span class="text-top">服务热线：{{webInfo.tel}}</span>
				</div>
			</div>
			<div class="flex-row items-center">
				<div class="flex-row items-center">
					<span class="text-top">{{$store.state.name}}</span>
				</div>
				<div class="line"></div>
				<div class="sign-out text-top" @click="logoutHandle">退出</div>
			</div>
		</div>
		<div class="banner-bottom">
			<img src="../../assets/image/LOGO-22.png" class="img-logo" />
			<div class="user-name">资源厂商工作台</div>
		</div>
		<div class="main">
			<div class="fixation">
				<div class="navigate">
					<el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @open="handleOpen"
						@close="handleClose" @select="handleSelect" text-color="#E3E3E3" active-text-color="#ffd04b"
						background-color="#434f66">
						<el-menu-item index="/factoryUser/index">
							<i class="el-icon-s-home"></i>
							<span slot="title">首页</span>
						</el-menu-item>
						<el-menu-item index="/factoryUser/factoryEqu">
							<i class="el-icon-s-tools"></i>
							<span slot="title">成套设备</span>
						</el-menu-item>
						<el-menu-item index="/factoryUser/factoryEme">
							<i class="el-icon-cpu"></i>
							<span slot="title">应急保电设备</span>
						</el-menu-item>
						<el-submenu index="">
							<template slot="title">
								<i class="el-icon-s-order"></i>
								<span>我的订单</span>
							</template>
							<el-menu-item index="/factoryUser/orderEqu">成套设备订单</el-menu-item>
							<el-menu-item index="/factoryUser/orderEme">应急保电订单</el-menu-item>
						</el-submenu>
						<el-menu-item index="/factoryUser/statistics">
							<i class="el-icon-s-marketing"></i>
							<span slot="title">统计分析</span>
						</el-menu-item>
						<!-- <el-menu-item index="/factoryUser/factoryAccount">
							<i class="el-icon-coin"></i>
							<span slot="title">资金账号管理</span>
						</el-menu-item> -->
						<el-menu-item index="/factoryUser/factoryEvaluate">
							<i class="el-icon-setting"></i>
							<span slot="title">我的评价</span>
						</el-menu-item>
						<el-submenu index="7">
							<template slot="title">
								<i class="el-icon-user-solid"></i>
								<span>个人中心</span>
							</template>
							<el-menu-item index="/factoryUser/factoryMineData">个人资料</el-menu-item>
							<el-menu-item index="/factoryUser/factoryMinePassword">密码管理</el-menu-item>
						</el-submenu>
						<el-menu-item index="/factoryUser/factoryTips">
							<i class="el-icon-chat-line-round"></i>
							<span slot="title">留言管理</span>
						</el-menu-item>
						<el-menu-item index="/factoryUser/customerServer">
							<i class="el-icon-service"></i>
							<span slot="title">联系客服</span><span  slot="title" v-if="weidu>0" style="color: red">(未读{{weidu}}条)</span>
						</el-menu-item>
					</el-menu>
				</div>
				<div class="view">
					<router-view :key="$route.fullPath"></router-view>
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<!--<div class="footer">
			备案号：{{webInfo.websiteNumber}}
		</div>-->

		<div class="footer">
			<a rel="noopenner noreferrer" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index"  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">{{webInfo.websiteNumber}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
			<a rel="noopenner noreferrer" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13019902000540" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/image/gaba.png" />
				<p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; ">冀公网安备 13019902000540号</p></a>
		</div>
		<!--备案号：-->
		<!--<div style="width:300px;margin:0 auto; padding:20px 0;">
			<a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">< img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">冀公网安备 13019902000540号</p ></a >
		</div>-->
	</div>
</template>

<script>
import {
	getUserWeidu,
	webInfoApi
} from '../../http/api/user.js'
	export default {
		data() {
			return {
				weidu:0,
				activeIndex: '/factoryUser/index',
				href:window.origin+"/wyyd_1.0.apk",
				webInfo: {}
			};
		},
		watch: {
			activeIndex(newValue, oldValue) {

			}
		},
		created() {
			this.getWebInfo()
			this.getweidu()
		},
		methods: {
			getweidu(){
				getUserWeidu({contactType:0}).then(res=>{
					this.weidu=res;
				})
			},
			handleOpen() {},
			handleClose() {},
			handleSelect(key, keyPath) {
				this.activeIndex = key;
				this.$router.push({
					path: key
				});
			},
			logoutHandle() {
				this.$store.dispatch('LogOut', this.$router)
			},
			getWebInfo() {
				webInfoApi().then(res => {
					this.webInfo = res
				})
			}
		}
	};
</script>

<style lang="less" scoped>
#unread-badge {
	position: absolute;
	display: inline;
	top: 10px;
	right: 10px;
	background-color: red;
	color: white;
	width: 20px;
	height: 20px;
	border-radius: 100%;
	padding: 5px;
	transform: translate(-50%, -50%);
	font-weight: bold;
	font-size: 20px;
}
	.outer {
		background-color: #f5f5f5;

		.banner-top {
			display: flex;
			justify-content: space-between;
			height: 40px;
			padding: 0 30px;
			font-size: 15px;
			background-color: #fbfbfb;
			color: #333333;
		}

		.banner-bottom {
			height: 80px;
			display: flex;
			align-items: center;
			background-color: white;
		}

	}

	.item-left {
		margin-right: 20px;
		cursor: pointer;
	}

	.image-icon {
		width: 12px;
		height: 12px;
		margin-right: 6px;
	}

	.item-right {
		margin-right: 0.32rem;
	}

	.img-user {
		width: 0.22rem;
		height: 0.22rem;
		margin-right: 0.1rem;
	}

	.line {
		width: 2px;
		height: 10px;
		background-color: #c4c4c4;
		margin: 0 10px;
	}

	.sign-out {
		color: #ff5252;
		cursor: pointer;
	}

	.bottom-left {
		height: 0.74rem;
	}

	.bottom-left a {
		text-decoration: none;
		display: flex;
		justify-content: center;
	}

	.img-logo {
		width: 126px;
		height: 55px;
		margin-right: 0.2rem;
		padding: 25px;
	}

	.banner-text {
		height: 0.51rem;
		align-self: flex-end;
	}

	.banner-item {
		height: 0.51rem;
	}

	.banner-margin {
		margin-right: 0.46rem;
	}

	.line-active {
		width: 0.64rem;
		height: 0.04rem;
	}

	.bottom-right {
		width: 4rem;
		height: 0.4rem;
		background: #f4f4f4;
		border-radius: 0.04rem;
		opacity: 1;
	}

	.img-search {
		width: 0.16rem;
		height: 0.17rem;
		margin: 0 0.17rem 0 0.14rem;
	}

	.main {
		width: 100%;

		.fixation {
			display: flex;
			justify-content: space-between;

			.view {
				width: calc(100% - 224px);
			}
		}
	}

	.search-input {
		height: 0.16rem;
		font-size: 0.16rem;
		padding: 0;
		border: none;
		outline: none;
		flex: 1 1 auto;
		background: #f4f4f4;
	}

	.holderclass {
		font-size: 0.16rem;
		color: #898989;
	}

	.footer-top {
		position: relative;
		-webkit-box-sizing: border-box;
		height: 2.49rem;
		background: #ffffff;
		padding-right: 0.1rem;
	}

	.section-one {
		margin-right: 2.72rem;
	}

	.section-one p {
		font-size: 0.14rem;
		margin: 0;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
		line-height: 0.2rem;
	}

	.section-one .text-title {
		margin-bottom: 0.14rem;
	}

	.link-item {
		font-size: 0.13rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #686868;
		line-height: 0.18rem;
		margin: 0.14rem 0 0.33rem;
	}

	.link-margin {
		margin-right: 0.28rem;
	}

	.text-item {
		width: 3.44rem;
		font-size: 0.13rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #686868;
		line-height: 0.23rem;
	}

	.line-footer {
		position: absolute;
		left: 50%;
		top: 50%;
		margin: -0.69rem 0 0 -0.005rem;
		width: 0.01rem;
		height: 1.38rem;
		background-color: #ebebeb;
	}

	.text {
		font-size: 0.18rem;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
		line-height: 0.25rem;
		margin-bottom: 0.1rem;
	}

	.call-button {
		width: 1.71rem;
		height: 0.32rem;
		background: #333333;
		border-radius: 0.21rem;
		font-size: 0.14rem;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #ffffff;
		line-height: 0.32rem;
		text-align: center;
	}

	.footer {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 30px;
		font-size: 12px;
	}

	.user-name {
		font-size: 20px;
		color: orange;
	}

	.el-menu-vertical-demo {
		width: 200px;
		border-radius: @vue-border-radius-base;
		overflow: hidden;
		border-top: 4px solid @vue-border-color-red;
		height: 100%;
	}

	.el-menu-item.is-active {
		background: #5d6a7c;
	}
</style>
